import React from 'react';
import {leadingZero} from '../utils/leading-zero';
import '../styles/time.scss';

export function Time({date}: {date: Date}): React.ReactElement {
  const h = leadingZero(date.getHours());
  const m = leadingZero(date.getMinutes());
  const dow = new Date(new Date()).toLocaleString('en', {
    weekday: 'long',
    day: '2-digit',
    month: 'short',
  });

  return (
    <div className="time-container">
      <div className="numbers">
        {h}
        <span className="dots">:</span>
        {m}
      </div>
      <div className="dow">{dow}</div>
    </div>
  );
}
